import React, { Component, Fragment } from "react";

import { connect } from "react-redux"
import * as actionCreators from "../../Store/actions/AuthAction";
import Modal from "../../Component/UI/Modal/Modal";
import Input from "../../Component/UI/Input/Input";
import pcariLogo from "../../assets/svg/pcariMainToolBarLogo.svg";
import FaceBookAuth from "../../assets/svg/FaceBookAuth.svg";
import Google from "../../assets/svg/Google.svg";
import classes from "./Authentication.module.css";
import Spinner from "../../Component/UI/spinner/Spinner";

class Authentication extends Component {

    state = {
        formValid: false,
        currentPass: '',
        signUpControls: {
            name: {
                inputType: 'input',
                label: 'Name',
                inputConfig: {
                    type: 'text',
                    placeholder: 'Your Name',
                    autoFocus: true
                },
                validation: {
                    required: true,
                },
                value: '',
                valid: false,
                touched: false
            },
            emailUP: {
                inputType: 'input',
                label: 'E-mail',
                inputConfig: {
                    type: 'text',
                    placeholder: ' Email address'
                },
                validation: {
                    required: true,
                    isEmail: true
                },
                value: '',
                valid: false,
                touched: false
            },
            passwordUP: {
                inputType: 'input',
                label: 'Password',
                inputConfig: {
                    type: 'password',
                    placeholder: 'password'
                },
                validation: {
                    required: true,
                    minLength: 7
                },
                value: '',
                valid: false,
                touched: false
            },
            password2: {
                inputType: 'input',
                label: 'Confirm password',
                inputConfig: {
                    type: 'password',
                    placeholder: 'Confirm password'
                },
                validation: {
                    required: true,
                    matchPass: true,
                },
                value: '',
                valid: false,
                touched: false
            }

        },
        controls: {
            emailIN: {
                inputType: 'input',
                label: 'E-mail',
                inputConfig: {
                    type: 'text',
                    placeholder: ' Username / Email address',
                    autoFocus: true
                },
                validation: {
                    required: true,
                    isEmail: true
                },
                value: '',
                valid: false,
                touched: false
            },
            passwordIN: {
                inputType: 'input',
                label: 'Password',
                inputConfig: {
                    type: 'password',
                    placeholder: 'password'
                },
                validation: {},
                value: '',
                valid: true,
                touched: false
            }
        },
        passwordRestControls: {
            email: {
                inputType: 'input',
                label: 'E-mail',
                inputConfig: {
                    type: 'text',
                    placeholder: 'Please insert your email address to reset your password',
                    autoFocus: true
                },
                validation: {
                    required: true,
                    isEmail: true
                },
                value: '',
                valid: false,
                touched: false
            }
        }
    }

    componentDidMount() {
        this.loadFbLoginApi();
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.user !== this.props.user) {
            this.props.showAuthHandler()
        }
        if (this.props.error) {
            setTimeout(() => { this.props.onClearError() }, 9000)
        }
    }

    cheekFieldVaild = (field, rule) => {
        let isVaild = true;
        let errMes = '';
        if (rule.required) {
            isVaild = field.trim() !== '' && isVaild;
            errMes = isVaild ? '' : 'This field is rquired';
        }
        if (rule.minLength) {
            isVaild = field.length > rule.minLength && isVaild;
            errMes = isVaild ? '' : 'Too short';
        }
        if (rule.isEmail) {
            // const patrr = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;
            const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            isVaild = pattern.test(field) && isVaild;
            errMes = isVaild ? '' : 'email : xx@yy.com'
        }
        if (rule.matchPass) {
            isVaild = field === this.state.currentPass && isVaild;
            errMes = isVaild ? '' : 'password dose not match';
        }
        return [isVaild, errMes]
    }

    inputChangeHandler = (event, elementID) => {
        let updatedControls;
        if (this.props.authMode === 'signIn') {
            updatedControls = { ...this.state.controls };
        }
        else if (this.props.authMode === 'signUp') {
            updatedControls = { ...this.state.signUpControls }
        }
        else if (this.props.authMode === 'passwordReset' || this.props.authMode === 'verifyEmail') {
            updatedControls = { ...this.state.passwordRestControls }
        }
        const changedElement = { ...updatedControls[elementID] };
        if (this.props.authMode === 'signUp' && changedElement.label === 'Password') {
            this.setState({ currentPass: event.target.value })
        }
        const checkVaildity = this.cheekFieldVaild(event.target.value, changedElement.validation);
        changedElement.valid = checkVaildity[0];
        changedElement.errMess = checkVaildity[1];
        changedElement.value = event.target.value
        changedElement.touched = true;
        updatedControls[elementID] = changedElement;
        let formValid = true
        for (let field in updatedControls) {
            formValid = updatedControls[field].valid && formValid;
        }
        if (this.props.authMode === 'signUp') {
            this.setState({ signUpControls: updatedControls, formValid: formValid })
        }
        else if (this.props.authMode === 'signIn') {
            this.setState({ controls: updatedControls, formValid: formValid })
        }
        else if (this.props.authMode === 'passwordReset' || this.props.authMode === 'verifyEmail') {
            this.setState({ passwordRestControls: updatedControls, formValid: formValid })
        }
    }


    onSubmitHandler = (event) => {
        event.preventDefault()
        const authData = {}
        let email = null,
            password = null;
        if (this.props.authMode === 'signIn') {
            for (let key in this.state.controls) {
                authData[key] = this.state.controls[key].value
            }
            email = authData.emailIN
            password = authData.passwordIN
        }
        else if (this.props.authMode === 'signUp') {
            for (let key in this.state.signUpControls) {
                if (key === 'emailUP' | key === 'passwordUP') {
                    authData[key] = this.state.signUpControls[key].value
                }
            }
            email = authData.emailUP
            password = authData.passwordUP
        }
        else if (this.props.authMode === 'passwordReset' || this.props.authMode === 'verifyEmail') {
            for (let key in this.state.passwordRestControls) {
                authData[key] = this.state.passwordRestControls[key].value
            }
            email = authData.email
        }
        // const requestData = {
        //     ...authData,
        //     returnSecureToken: true
        // }
        // const { email, password } = requestData
        if (this.state.formValid) {
            this.props.onStartAuth(email, password, this.props.authMode)
        }
        if (this.props.authMode === 'passwordReset') {
            this.props.showAuthHandler('signIn')
        }
        if(this.props.authMode === 'signUp' && this.state.formValid){
            this.props.showAuthHandler('signIn', true)
        }
    }

    // ############################ FACEBOOK SDK ############################### :

    loadFbLoginApi() {

        window.fbAsyncInit = function () {
            window.FB.init({
                appId: '893909957766449',
                cookie: true,
                xfbml: true,
                version: 'v8.0'
            });

            window.FB.AppEvents.logPageView();

        };

        (function (d, s, id) {
            var js, fjs = d.getElementsByTagName(s)[0];
            if (d.getElementById(id)) { return; }
            js = d.createElement(s); js.id = id;
            js.src = "https://connect.facebook.net/en_US/sdk.js";
            fjs.parentNode.insertBefore(js, fjs);
        }(document, 'script', 'facebook-jssdk'));

    }

    statusChangeCallback(response) {
        if (response.status === 'connected') {
            this.testAPI();
        } else if (response.status === 'not_authorized') {
            console.log("Please log into this app.");
        } else {
            console.log("Please log into this facebook.");
        }
    }

    checkLoginState() {
        window.FB.getLoginStatus(function (response) {
            this.statusChangeCallback(response);
        }.bind(this));
    }

    handleFBLogin() {
        window.FB.login(this.checkLoginState());
    }

    // ###############################################################

    render() {
        const authForm = [];
        if (this.props.authMode === 'signUp') {
            for (let key in this.state.signUpControls) {
                authForm.push(
                    {
                        id: key,
                        config: this.state.signUpControls[key]
                    })
            }
        }
        else if (this.props.authMode === 'signIn') {
            for (let key in this.state.controls) {
                authForm.push(
                    {
                        id: key,
                        config: this.state.controls[key]
                    })
            }
        }
        else if (this.props.authMode === 'passwordReset') {
            for (let key in this.state.passwordRestControls) {
                authForm.push(
                    {
                        id: key,
                        config: this.state.passwordRestControls[key]
                    })
            }
        }
        else if (this.props.authMode === 'verifyEmail') {
            for (let key in this.state.passwordRestControls) {
                authForm.push(
                    {
                        id: key,
                        config: this.state.passwordRestControls[key]
                    })
            }
        }
        const form =
            (
                <form onSubmit={this.onSubmitHandler}>
                    {authForm.map(inputElement => {
                        return <Input
                            key={inputElement.id}
                            label={inputElement.config.label}
                            inputType={inputElement.config.inputType}
                            inputconfig={inputElement.config.inputConfig}
                            invalid={!inputElement.config.valid}
                            errMess={inputElement.config.errMess}
                            touched={inputElement.config.touched}
                            changed={(event) => { this.inputChangeHandler(event, inputElement.id) }}
                        />
                    })}
                    <button 
                    type='submit'  
                    className={classes.Btn}> {
                        this.props.authMode === 'signIn' ?
                            'Sign In'
                            :
                            this.props.authMode === 'signUp' ?
                                'Sign Up'
                                :
                                this.props.authMode === 'passwordReset' || this.props.authMode === 'verifyEmail' ?
                                    'Send email'
                                    :
                                    null
                    }</button>
                    {this.props.authMode === 'signIn' ?
                        <Fragment>
                            <div
                                className={classes.ForgetPass}
                                onClick={() => { this.props.showAuthHandler('passwordReset', true) }}
                            >
                                <small>Forgot your password?</small>
                            </div>
                            <div className={classes.SocialAuth}><div></div> or<div></div></div>
                            <p className={classes.SignWith}>Sign in with</p>
                            <div className={classes.SocialAuth}>
                                <button
                                    className={classes.IconBtn}
                                    onClick={() => {
                                        this.props.onFacebookAuth()
                                    }}
                                >
                                    <img src={FaceBookAuth} alt='' />
                                </button>
                                <button
                                    className={classes.IconBtn}
                                    onClick={() => {
                                        this.props.onGoogleAuth()
                                    }}
                                >
                                    <img src={Google} alt='' />
                                </button>

                            </div>
                            <p>
                                <small style={{ fontSize: '.8rem' }}>
                                    don't have account ?
                                    <button
                                        className={classes.DontHave}
                                        type="button"
                                        onClick={() => { this.props.showAuthHandler('signUp', true) }}>
                                        Signup
                                    </button>
                                </small>
                            </p>
                        </Fragment>
                        :
                        this.props.authMode === 'signUp' ?
                            <p>
                                <small style={{ fontSize: '.8rem' }}>
                                    already have account ?
                                    <button
                                        className={classes.DontHave}
                                        type="button"
                                        onClick={() => { this.props.showAuthHandler('signIn', true) }}>
                                        Sign In
                                    </button>
                                </small>
                            </p>
                            :
                            null
                    }
                </form>
            );
        return (
            <Fragment>
                <Modal showModal closeModal={this.props.showAuthHandler}>
                    <img src={pcariLogo} alt='PCARI LOGO' width='40%' style={{ margin: '2% 30%' }} />
                    {form}
                    {this.props.loadingAuth ? <Spinner /> : null}
                    {this.props.error ? <small style={{ color: 'red' }}>{this.props.error}</small> : null}
                </Modal>
            </Fragment>
        );
    }
}

const mapStateToProps = state => {
    return {
        loadingAuth: state.Auth.loadingAuth,
        user: state.Auth.user,
        error: state.Auth.error
    }
};

const mapDispatchToProps = dispatch => {
    return {
        onStartAuth: (email, password, mode) => { dispatch(actionCreators.startAuth(email, password, mode)) },
        onGoogleAuth: () => { dispatch(actionCreators.googleAuth()) },
        onFacebookAuth: () => { dispatch(actionCreators.facebookAuth()) },
        onClearError: () => { dispatch(actionCreators.clearError()) }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Authentication);